"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSettingsFromConfig = exports.isUndefined = void 0;
var ProjectConfig_1 = require("./ProjectConfig");
var isUndefined = function (comp) { return comp === undefined; };
exports.isUndefined = isUndefined;
function getSettingsFromConfig(json) {
    return Object.fromEntries(Object.entries(json[ProjectConfig_1.ConfigFile.FeatureFlags]).map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key, ProjectConfig_1.Setting.fromJson(value)];
    }));
}
exports.getSettingsFromConfig = getSettingsFromConfig;
